import React, { ReactElement } from 'react'
import Step2Form from './Step2Form'
import StepTitle from '../StepTitle'
import { IStepProps } from '../../interfaces/Step'
import TooltipWrapper from '../tooltips/TooltipWrapper'
import Step2Tooltip from '../tooltips/Step2Tooltip'

// TODO: Refactore this step and render form based on journey type (HR or MR)
const Step2 = (props: IStepProps): ReactElement => {
  const { title } = props

  return (
    <>
      <StepTitle title={title}>
        <TooltipWrapper title="Pourquoi ces informations ?">
          <Step2Tooltip />
        </TooltipWrapper>
      </StepTitle>

      <Step2Form {...props} />
    </>
  )
}

export default Step2
